import React, {useCallback, useContext} from 'react';
import {EditorContext, useEditorState} from "@tiptap/react";
import {FaAlignCenter, FaAlignJustify, FaAlignLeft, FaAlignRight} from "react-icons/fa";

const alignIcon = {
    left: FaAlignLeft,
    center: FaAlignCenter,
    right: FaAlignRight,
    justify: FaAlignJustify,
}

const alignTitle = {
    left: "Alinhar à esquerda (Ctrl+Shift+L)",
    center: "Alinhar no centro (Ctrl+Shift+E)",
    right: "Alinhar à direita (Ctrl+Shift+R)",
    justify: "Justificar (Ctrl+Shift+J)"
}

const RichTextAlignButton = ({align}) => {
    const {editor} = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null;

    return <RichTextAlignButtonContent editor={editor} align={align}/>;
};

const RichTextAlignButtonContent = ({editor, align}) => {
    const isActive = useEditorState({
        editor,
        selector: ({editor}) => !!editor?.isActive({textAlign: align}),
    });

    const Icon = alignIcon[align];

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();
            if (!editor || editor.isDestroyed) return;
            editor.chain().focus().setTextAlign(align).run();
        },
        [editor, align]
    );

    if (!Icon) return null;

    return (
        <button
            type="button"
            className={"rich-text-button" + (isActive ? " active" : "")}
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleClick}
            title={alignTitle[align]}
        >
            <Icon className="rich-text-button-icon"/>
        </button>
    );
};

export default RichTextAlignButton;
